import script from "./WorkKpiDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkKpiDefault.vue?vue&type=script&setup=true&lang=js"

import "./WorkKpiDefault.vue?vue&type=style&index=0&id=1250294a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1250294a"]])

export default __exports__